"use client"

import Link from "next/link";
import React, { useState, useEffect } from "react";
import dynamic from 'next/dynamic';

// Dynamically import ChatPod with SSR disabled
const ChatPod = dynamic(
  () => import("@/app/components/aws/connect/ChatPod"),
  { ssr: false, loading: () => null }
);

// Component to lazily load the chat pod after page render
const LazyLoadChatPod = () => {
    const [showChat, setShowChat] = useState(false);
    
    useEffect(() => {
        // Only load chat pod after page is fully loaded and a delay
        const timer = setTimeout(() => {
            setShowChat(true);
        }, 5000); // 5 second delay after page load
        
        return () => clearTimeout(timer);
    }, []);
    
    return showChat ? <ChatPod /> : null;
};

const navigation = {
    main: [
        { name: 'IT Solutions', href: '/itsolutions' },
        { name: 'Websites', href: '/websites' },
        { name: 'Apps', href: '/apps' },
        { name: 'Back End', href: '/backend' },
        { name: 'DevOps', href: '/devops' },
        { name: 'Contact', href: '/contact' },
    ],
    legal: [
        { name: 'Privacy Policy', href: '/privacypolicy' },
        { name: 'Cookie Policy', href: '/cookiepolicy' },
        { name: 'Terms & Conditions', href: '/termsconditions' },
    ],
}

export default function Footer() {
    return (
        <footer className="bg-white relative">
            <div className="mx-auto max-w-7xl overflow-hidden px-6 py-20 sm:py-24 lg:px-8">
                <nav aria-label="Footer" className="-mb-6 flex flex-wrap justify-center gap-x-12 gap-y-3 text-sm/6">
                    {navigation.main.map((item) => (
                        <Link key={item.name} href={item.href} className="text-gray-600 hover:text-gray-900">
                            {item.name}
                        </Link>
                    ))}
                </nav>
                <div className="mt-8 flex justify-center space-x-6">
                    {navigation.legal.map((item) => (
                        <Link key={item.name} href={item.href} className="text-xs text-gray-500 hover:text-gray-700">
                            {item.name}
                        </Link>
                    ))}
                </div>
                <p className="mt-6 text-center text-sm/6 text-gray-600">&copy; 2025 FullStack Software Labs. All rights
                    reserved.</p>
            </div>

            {/* AWS Connect Chat Pod - Lazily loaded */}
            <div id="chat-pod-container">
                {/* ChatPod will be loaded after page content is fully rendered */}
                <LazyLoadChatPod />
            </div>


        </footer>
    )
}